import {useState, useEffect, useMemo} from 'react';
import Select from 'react-select';

const SelectValidPotCli = ({
    id,
    value,
    onChange,
    isInvalid,
    isClearable,
    disabled,
    defaultProps
}) => {
    const [selectedValue, setSelectedValue] = useState(value);
    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };
    const options = [
        {
            label: 'Nombre Completo',
            value: 'nombreCompleto_c',
            tipo: 'texto'
        },
        {
            label: 'Tipo Documento',
            value: 'tipoDoc_c',
            tipo: 'select'
        },
        {
            label: 'Documento',
            value: 'documento_c',
            tipo: 'texto'
        },
        {
            label: 'Barrio',
            value: 'barrio_c',
            tipo: 'texto'
        },
        {
            label: 'Direccion',
            value: 'direccion_c',
            tipo: 'texto'
        },
        {
            label: 'Correo',
            value: 'email_c',
            tipo: 'texto'
        },
        {
            label: 'Celular',
            value: 'celular_c',
            tipo: 'texto'
        },
        {
            label: 'Latitud',
            value: 'latitud_c',
            tipo: 'texto'
        },
        {
            label: 'Longitud',
            value: 'longitud_c',
            tipo: 'texto'
        },
        {
            label: 'Codigo Postal',
            value: 'cpostal_c',
            tipo: 'select'
        },
        {
            label: 'Canal de Comunicacion',
            value: 'canalcomu_c',
            tipo: 'select'
        },
        {
            label: 'IVA',
            value: 'iva_c',
            tipo: 'select'
        },
        {
            label: 'Estado Cliente',
            value: 'estadoCliente_c',
            tipo: 'select'
        },
        {
            label: 'Localidad Calendar',
            value: 'lugarId_c',
            tipo: 'select'
        },
        {
            label: 'Creado Por',
            value: 'createdPersonaId_c',
            tipo: 'select'
        }
    ]

    useEffect(() => {
        if (typeof value === 'string') {
            setSelectedValue(options.find((opt) => opt.value === value));
        }
    }, [value]);
    const customStyles = useMemo(() => ({
        menuPortal: (base) => ({...base, zIndex: 9999}),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#000',
            background: state.isSelected ? '#0364ff' : '#fff',
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        multiValue: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: '#0364ff',
                borderRadius: 5
            };
        },
        multiValueLabel: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5
        }),
        multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: '#fff',
            borderRadius: 5,
            '&:hover': {
                backgroundColor: '#02378c',
                color: '#fff',
            },
        }),
        control: (styles)=>({
            ...styles,
            borderRadius: 7,
            borderColor: 'gray'
        })
    }), [])
    return (
        <Select
            {...defaultProps}
            inputId={id}
            className={`react-select-container ${
                isInvalid ? 'is-invalid' : ''
            }`}
            styles={customStyles}
            menuPortalTarget={document.body}
            classNamePrefix="react-select"
            placeholder="Seleccione..."
            options={options}
            value={selectedValue}
            onChange={onSelectValue}
            isClearable={isClearable}
            isDisabled={disabled}
            menuShouldScrollIntoView
            menuPosition='absolute'
            menuPlacement='auto'
        />
    );
};

SelectValidPotCli.defaultProps = {
    isClearable: false,
    value: null
};

export default SelectValidPotCli;